import React, { useState } from 'react';
import {
  Button, Input, Label, Pagination, PaginationItem, PaginationLink,
  Modal, ModalBody, FormGroup
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';

export function updateAtPath(obj, path, newValue) {
  if (path.length === 0) {
    return newValue;
  }
  const [head, ...rest] = path;
  let clone;
  if (Array.isArray(obj)) clone = [...obj];
  else if (obj && typeof obj === "object") clone = { ...obj };
  else {
    clone = typeof head === "number" ? [] : {};
  }

  clone[head] = updateAtPath(clone[head], rest, newValue);
  return clone;
}

const fields = {
  "LawTitle": { path: ["document_info", "law_title"] },
  "LawType": { path: ["document_info", "document_type"] },
  "LawNo": { path: ["document_info", "document_number"] },
  "LawStatus": { path: ["document_info", "document_status_capture"] }
}

const LawDocument = ({ show, setShow, selectedRow, setSelectedRow, fieldKey,  onSaveClickHandler }) => {
  const { t, i18n } = useTranslation();

  const handleSelectChange = (e, index) => {
    const { name, value } = e.target;

    setSelectedRow(prev => {
      const oldValue = prev[name][index];   // old instrument_type

      // 1. Update unique list
      const updatedInstrumentTypes = prev[name].map((item, idx) =>
        idx === index ? value : item
      );

      // 2. Update ALL articles whose instrument_type matches oldValue
      const updatedArticles = prev.Json.articles?.map(article => ({
        ...article,
        instrument_type:
          article.instrument_type === oldValue ? value : article.instrument_type
      }))

      return {
        ...prev,
        [name]: updatedInstrumentTypes,
        Json: {
          ...prev.Json,
          articles: updatedArticles
        }
      };
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    const path = fields[name]?.path || [];
    
    const updated = updateAtPath(selectedRow.Json, path, value);

    setSelectedRow((prev) => ({
      ...prev, 
      [name]: value,
      Json: updated
    }));
  };

  const {legalRank, lawStatus, instrumentType } = useSelector(
    (state) => ({
      legalRank: state.LegalRank.legalRank,
      lawStatus: state.LawReport.lawStatus,
      instrumentType: state.LawReport.instrumentType
    })
  );

  return (
    <Modal isOpen={show} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-start">
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <label htmlFor={fieldKey} className="col-form-label">{t(fieldKey)}<small className="text-danger"> *</small></label>
            { fieldKey === 'LawTitle' ?
              <Input
                type="textarea"
                row="2"
                className="form-control"
                placeholder={t(selectedRow)}
                value={selectedRow[fieldKey] || ''}
                name={fieldKey}
                onChange={handleChange}
                required
              /> : 
              fieldKey === 'LawType' ?
              <Input
                type="select"
                className="form-select"
                name={fieldKey}
                value={(selectedRow[fieldKey] || '').trim()}
                onChange={handleChange}
                required
              >
                <option value="">{t("Select")}</option>
                {legalRank?.map((type) => (
                  <option value={type.DocTypeAr} key={type.ID}>
                    {i18n.language === 'en' ? `${type.DocTypeEn} (${type.LegalRankEn})` : `${type.DocTypeAr} (${type.LegalRankAr})`}
                  </option>
                ))}
              </Input> :
              fieldKey === 'LawStatus' ?
              <Input
                type="select"
                className="form-select"
                name={fieldKey}
                value={(selectedRow[fieldKey] || '').trim()}
                onChange={handleChange}
                required
              >
                <option value="">{t("Select")}</option>
                {lawStatus?.map((status) => (
                  <option value={status.NameAr} key={status.ID}>
                    {i18n.language === 'en' ? status.NameEn : status.NameAr}
                  </option>
                ))}
              </Input> :
              fieldKey === 'InstrumentType' && Array.isArray(selectedRow[fieldKey]) ? 
              Array.isArray(selectedRow[fieldKey]) && selectedRow[fieldKey]?.map((instType, index) => {
                return (
                  <Input
                    key={index}
                    type="select"
                    className="form-select mb-3"
                    name={fieldKey}
                    value={(instType || '').trim()}
                    onChange={(e) => handleSelectChange(e, index)}
                    required
                  >
                    <option value="">{t("Select")}</option>
                    {instrumentType?.map((type) => (
                      <option value={type.NameAr} key={type.ID}>
                        {i18n.language === 'en' ? type.NameEn : type.NameAr}
                      </option>
                    ))}
                  </Input>
                )
              })
              : null
              }
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={() => setShow(false)}
          >
            {t("Close")}
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger d-flex align-items-center"
            onClick={onSaveClickHandler}
          >
            {t('Yes, Save it')}
          </button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default LawDocument